// extracted by mini-css-extract-plugin
module.exports = {"button":"_9330de7794--button--wvpRY","dark":"_9330de7794--dark--HdtBl"};